import { TicketPriority } from '@/services/TicketsService';

export function getPriorityClassName(priority: TicketPriority) {
  const classes: Record<TicketPriority, string> = {
    low: 'border-emerald-200 bg-emerald-50 text-emerald-700',
    high: 'border-amber-200 bg-amber-50 text-amber-700',
    critical: 'border-red-200 bg-red-50 text-red-700',
  };

  return classes[priority];
}
